import { fetchJsonResponse } from '@/ai/api'
import { buildCommentReplyPrompt } from '@/ai/prompts'

export const generateCommentReply = async ({
  workflow,
  cardTypes,
  input,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildCommentReplyPrompt({
    workflow,
    cardTypes,
    input
  })

  const response = await fetchJsonResponse({
    messages,
    useCase: 'cards',
    aiVersion: workflow.aiVersion,
    signal: abortController?.signal
  })

  return response || null
}
